import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { useMobxStores } from '@stores/store';
import { isEmpty as _isEmpty } from 'lodash';
import { t } from 'i18next';

// import VideoJS from "@app/components/atoms/Video";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper';
import { isIOS, isMobile, comTracking } from '@helpers/EnvHelper';
import { useNavigate } from 'react-router-dom';

import useShrink from '@hook/useShrink';
import { useWindowSize } from 'usehooks-ts';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import '@style/MainBannerSlide.scss';

import MediaSlideData from '@organisms/media/MediaSlideData';

import { useTranslation } from 'react-i18next';

const SlideNextButton = ({ onClickSlideBtn }) => {
  return (
    <button onClick={() => onClickSlideBtn('next')} className="h-full">
      <img
        src="/img/media/slider-g-arrow.svg"
        alt=""
        className="h-full !w-auto"
      />
    </button>
  );
};
const SlidePrevButton = ({ onClickSlideBtn }) => {
  return (
    <button onClick={() => onClickSlideBtn('prev')} className="h-full">
      <img
        src="/img/media/slider-g-arrow.svg"
        alt=""
        className="h-full !w-auto"
      />
    </button>
  );
};

const MediaSlideWrapper = ({ category, rows }) => {
  const { mediaStore, settingStore } = useMobxStores();
  const { t, i18n } = useTranslation();
  const { width } = useWindowSize();
  useShrink(width > 1280 ? 720 : 100);
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const onClickSlideBtn = type => {
    if (type === 'next') {
      swiperRef.current?.swiper.slideNext();
    } else if (type === 'prev') {
      swiperRef.current?.swiper.slidePrev();
    }
  };

  return (
    <div className="media relative mt-[30px]">
      {!_isEmpty(rows) && rows.length > 0 && (
        <p className="pb-3 text-[18px] xl:text-[20px] font-extrabold font-TmoneyRoundWind">
          {category[`${i18n.language === 'kr' ? 'ko' : i18n.language}Category`]}
        </p>
      )}

      {!_isEmpty(rows) && rows.length > 0 && (
        <div className="relative">
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            speed={1200}
            loop={!_isEmpty(rows) && rows.length > 4 ? true : false}
            slidesPerView={4}
            spaceBetween={20}
            threshold={100}
            className="bg-none cursor-pointer"
            ref={swiperRef}
          >
            {!_isEmpty(rows) &&
              rows.map((slide, idx) => {
                return (
                  <SwiperSlide
                    key={`banner_${slide.boardIdx}`}
                    className="bg-none"
                  >
                    {<MediaSlideData data={slide} />}
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      )}

      {!_isEmpty(rows) && rows.length > 4 && (
        <>
          <div className="absolute h-[37px] right-[-45px] xl:h-[60px] xl:right-[-60px] xl:mt-[-10px]  top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
            <SlideNextButton onClickSlideBtn={onClickSlideBtn} />
          </div>
          <div className="absolute h-[37px] left-[-45px] xl:h-[60px] xl:left-[-60px] xl:mt-[-10px] rotate-180 top-1/2 translate-x-1/2 -translate-y-1/2 z-10">
            <SlidePrevButton onClickSlideBtn={onClickSlideBtn} />
          </div>
        </>
      )}
    </div>
  );
};

export default observer(MediaSlideWrapper);
